import Component from '@glimmer/component';
import moment from 'moment-timezone';

import { action } from '@ember/object';

export default class DetailCalendarComponent extends Component {
  get wrapDate() {
    return this.args.start_date
      ? moment(this.args.start_date).format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD');
  }

  /*@computed('wrapDate')
    get days() {
        let arrDates = [];

        for(let i = 0; i < 7; i++) {
        	arrDates.push(moment(this.wrapDate).add(i, 'days').format('YYYY-MM-DD'))
        }

       return arrDates;
    }*/

  @action
  _addDate(month = true) {
    const date = moment(this.wrapDate);

    if (month) {
      date.add(1, 'months').startOf('month');
    } else {
      date.add(7, 'days');
    }

    if (this.args.setDate) {
      this.args.setDate(date.format('YYYY-MM-DD'));
    }

    if (this.args.reloadTask) {
      this.args.reloadTask.perform();
    }
  }

  @action
  _subtractDate(month = true) {
    const date = moment(this.wrapDate);

    if (month) {
      date.subtract(1, 'months').startOf('month');
    } else {
      date.subtract(7, 'days');
    }

    if (this.args.setDate) {
      this.args.setDate(date.format('YYYY-MM-DD'));
    }

    if (this.args.reloadTask) {
      this.args.reloadTask.perform();
    }
  }
}
